import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Badge, Box, Button, Divider, Image, MenuButton, Paragraph, Spinner, Text, useColorMode } from "theme-ui";
import { GetLatestTimeById, GetTimeById, getAllSubtask, getAllSubtaskSummary, getHistoryByView, getAllSubtaskSummarySuccess, getAllSubtaskSuccess, getAllDuplicateSubtasksSuccess, needInfo, getAllDuplicateSubtasks, getAllSubtasksOfSameTask } from "../../store/actions/project.action";
import activity from "../assets/images/Icon/activity.svg";
import spent from "../assets/images/Icon/spent.svg";
import taskIcon from "../assets/images/Icon/frontapp.svg";
import deleteIcon from "../../Components/assets/images/Icon/delete.svg";
import notification1 from "../assets/images/Notification1.svg";
import AddAction from "../Actions/AddAction";
import ThreadModalPop from "../ThreadModalPop/ThreadModalPop";
import { bucketUrl } from "../../utils/global";
import { RootState, ISubtaskBadgeData, IChecklistTemplate } from "../../../@types";
import { Inputform } from "../forms-component/InputForm";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { FaPlus } from "react-icons/fa";
import { addDescriptionActionHighlight, addDescriptionBulkActionHighlight, createActionHighlight, deleteMultipleActionHighlight, getActionByName, getActionHighlighterIds, getAllTemplateChecklist } from "../../store/actions/action.Highlighters";
import HistoryAction from "./HistoryAction";
import { ActionCard } from "../Actions/ActionModule/SubTaskActionCard";
import { deleteTask } from "../../store/actions/masterData.action";
import { deleteTaskByIdApi } from "../../store/api";
import { checkDeletionPermission } from "../../utils/GenerateQueryString";
import toast from 'react-hot-toast';
import FormSelect from "../forms-component/globalSelect";
import theme from "../../theme";
import clockleft from "../../Components/assets/images/clock-left.svg";
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import InfiniteScroll from "react-infinite-scroll-component";
import ActivityHistoryModal from "../pages/demotable/ActivityHistoryModal";
import ActivityRevertHistory from "../pages/demotable/ActivityRevertHistory";
import { AllActivities, getUserName } from "../../utils/activityHistoryHelper";

const SideActions: React.FC<any> = ({ isTracking, elapsedTime, taskId, stageId, projectId, threads, timeStatusColor }) => {

    const { historyView, spentTime, Latesttime, tasksView, AllSubtask, allDuplicateSubtasks, stagebyproject, loader: historyLoader } = useSelector((state: any) => state.project);
    const { auther } = useSelector((state: RootState) => state.auth);
    const [showAll, setShowAll] = useState(false);
    const [items, setItems] = useState<any[]>([]);
    const [totalItems, setTotalItems] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const lastFetchRef = useRef("");
    const fetchingRef = useRef("");
    const limit = 25;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [selectedTab, setSelectedTab] = useState('activity');
    const { dataForTable } = useSelector((state: any) => state.masterData);
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [historyModalOpen, setHistoryModalOpen] = useState<boolean>(false);
    const [textareaValue, setTextareaValue] = useState("");
    const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
    const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
    const is_Project_Worker = auther?.Role?.map(role => role?.RoleName).some(role => role.toLocaleLowerCase() === "project worker");
    const is_Project_Manager = auther?.Role?.map(role => role?.RoleName).some(role => role.toLocaleLowerCase() === "project manager");
    const is_Super_Admin = auther?.Role?.map(role => role?.RoleName).some(role => role.toLocaleLowerCase() === "super admin");
    const [showConfirmationTask, setShowConfirmationTask] = useState<boolean>(false);
    const totalMilliseconds = spentTime?.totalTimeOfTodoPerReview;
    const hours = Math.floor(totalMilliseconds / (1000 * 60 * 60));
    const minutes = Math.floor((totalMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((totalMilliseconds % (1000 * 60)) / 1000);
    const [deleteIdList, setDeleteIdList] = useState<string[]>([]);
    const allowRoles = auther?.Role?.map(role => role?.RoleName).some(role => role.toLocaleLowerCase() === "super admin" || role.toLocaleLowerCase() === "Region Admin");
    const timeInHoursMinutesSeconds =
        (hours > 0 ? `${hours}h ` : '') +
        `${minutes}m ${seconds.toString().padStart(2, '0')}s`;
    const handleTabClick = (tab: any) => {
        const wasAlreadyActive = tab === 'activity' && selectedTab === 'activity';
        setSelectedTab(tab);
        if (tab === 'activity') {
            setPageNumber(1);
            setItems([]);
            setHasMore(true);
            fetchingRef.current = "";
            lastFetchRef.current = "";
            if (wasAlreadyActive) {
                const currentPayload = `taskId=${taskId}&page=1&limit=${limit}`;
                fetchingRef.current = currentPayload;
                lastFetchRef.current = currentPayload;
                dispatch(getHistoryByView(currentPayload));
            }
        }
    };

    const toggleActivityModal = () => {
        setModalOpen(!modalOpen);
    };
    const toggleHistoryModal = () => setHistoryModalOpen(!historyModalOpen);
    const cancelMultipleDeleteTask = () => {
        setShowConfirmationTask(false);
    };
    useEffect(() => {
        setPageNumber(1);
        setItems([]);
        setHasMore(true);
        fetchingRef.current = "";
        lastFetchRef.current = "";
    }, [taskId]);

    useEffect(() => {
        if (historyView === null) {
            setPageNumber(1);
            setItems([]);
            setHasMore(true);
            fetchingRef.current = "";
            lastFetchRef.current = "";
        }
    }, [historyView === null]);

    useEffect(() => {
        const currentPayload = `taskId=${taskId}&page=${pageNumber}&limit=${limit}`;
        if (selectedTab === 'activity' && currentPayload !== fetchingRef.current) {
            if (currentPayload !== lastFetchRef.current || historyView === null) {
                dispatch(getHistoryByView(currentPayload));
                fetchingRef.current = currentPayload;
                lastFetchRef.current = currentPayload;
            }
        }
    }, [dispatch, pageNumber, taskId, selectedTab]);

    useEffect(() => {
        if (historyView?.data && !historyLoader) {
            fetchingRef.current = ""; // Reset fetching ref on success
            if (pageNumber === 1) {
                setItems(historyView?.data);
            } else {
                setItems((prevItems) => [...prevItems, ...historyView?.data]);
            }

            if (historyView?.count !== undefined) {
                setTotalItems(historyView?.count);
            }
            if ((historyView?.data?.length || 0) < limit) {
                setHasMore(false);
            } else {
                setHasMore(true);
            }
        }
    }, [historyView?.data, pageNumber, taskId, historyLoader]);

    const fetchMoreData = () => {
        if (items?.length >= totalItems) {
            setHasMore(false);
            return;
        }
        const nextPage = pageNumber + 1;
        setPageNumber(nextPage);
    };
    const uniqueItems = useMemo(() => {
        const seen = new Set();
        const listToUse = (historyView?.data && Array.isArray(historyView.data) && historyView.data.length > 0) ? historyView.data : items;
        return listToUse?.filter((history: any) => {
            const identifier = history?._id || history?.id || history?.changes?.updatedAt || history?.changes?.updateObject?.updatedAt || history?.updatedAt || history?.createdAt;
            if (seen.has(identifier)) {
                return false;
            } else {
                seen.add(identifier);
                return true;
            }
        });
    }, [historyView?.data, items]);
    useEffect(() => {
        dispatch(GetTimeById(taskId));
        dispatch(GetLatestTimeById(taskId))
    }, [dispatch])
    useEffect(() => {
        if (isTracking) {
            setSelectedTab('spent');
        }
    }, [isTracking]);
    function convertMillisecondsToHoursMinutesSeconds(milliseconds: number) {
        let seconds = Math.floor(milliseconds / 1000);
        const days = Math.floor(seconds / 86400);
        seconds %= 86400;
        const hours = Math.floor(seconds / 3600);
        seconds %= 3600;
        const minutes = Math.floor(seconds / 60);
        seconds %= 60;
        return { days, hours, minutes, seconds };
    }

    const handleTextareaChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setTextareaValue(event.target.value);
    };
    const togglePopover = () => {
        setIsPopoverOpen(!isPopoverOpen);
    };
    const handleSend = () => {
        const payload = {
            actionType: "NEED_INFO",
            payload: {
                description: textareaValue
            }
        }
        dispatch(needInfo(payload, taskId))
        setIsPopoverOpen(false);
    };

    const handlePopoverOpen = (event: React.MouseEvent<HTMLImageElement>) => {
        setIsPopoverOpen(true);
    };

    const { loader, templateList, actionHighlights, createHighlight, } = useSelector((state: any) => state.actionHighlight)


    // Subtask Implement
    const [selectedTemplates, setSelectedTemplates] = useState<any>();
    const templateOptions: any = templateList?.map((template: IChecklistTemplate) => ({
        label: template.templateName,
        value: template._id,
        checklistItem: template?.checklistItem
    }));

    const initialValues = {
        name: ""
    }

    const refreshSubtaskData = () => {
        const effectiveActionObj = { projectId: projectId, stageId: stageId || tasksView?.stageDataId?._id || tasksView?.stageDataId, taskId };
        if (effectiveActionObj?.projectId && effectiveActionObj?.stageId && effectiveActionObj?.taskId) {
            dispatch(getAllSubtaskSummary(effectiveActionObj));
            dispatch(getAllSubtask(effectiveActionObj));
        }
        if (taskId) {
            dispatch(getAllDuplicateSubtasks(taskId));
        }
    };



    const formik = useFormik(
        {
            enableReinitialize: true,
            initialValues,
            validationSchema: Yup.object({
                name: Yup.string().required('Check list item is required'),
            }),
            onSubmit: (value: any) => {
                value["ischecked"] = false;
                value["isReviewed"] = false;
                value["isDone"] = false;
                const currentActionObj = { projectId: projectId, stageId: stageId || tasksView?.stageDataId?._id, taskId };
                if (actionHighlights?._id) {

                    const updateData = {
                        data: value,
                        ...currentActionObj,
                        actionType: "Subtask",
                    }
                    dispatch(addDescriptionActionHighlight(updateData, actionHighlights?._id, () => {
                        refreshSubtaskData();
                    }))
                } else {
                    const payload = {
                        actionType: "Subtask",
                        payload: {
                            Description: [value]
                        },
                        ...currentActionObj
                    }
                    dispatch(createActionHighlight(payload, () => {
                        refreshSubtaskData();
                    }))
                }
                setActiveTab(0);
                lastFetchRef.current = "";
                fetchingRef.current = "";
                setPageNumber(1);
                formik.resetForm()
            }
        }
    );

    const { handleSubmit, setFieldValue, values, handleBlur, touched, errors } = formik;
    let actionObject: any = { projectId: projectId, stageId: tasksView?.stageDataId?._id, taskId }

    const handleTemplateChange = (selected: any) => {
        const selectedTemplates = {
            _id: selected?.value?._id,
            name: selected?.value?.templateName,
        };
        const data = selected?.checklistItem.map((template: any) => ({
            comment: [],
            name: template,
            isChecked: false,
            isReviewed: false,
            isDone: false,
        }));

        const currentActionObj = { projectId: projectId, stageId: stageId || tasksView?.stageDataId?._id, taskId };
        if (actionHighlights?._id) {
            const updateData = {
                data,
                ...currentActionObj,
                actionType: 'Subtask',
            };

            dispatch(addDescriptionBulkActionHighlight(updateData, actionHighlights?._id, () => {
                refreshSubtaskData();
            }));
        } else {
            const payload = {
                actionType: 'Subtask',
                payload: {
                    Description: data
                },
                ...currentActionObj
            };

            dispatch(createActionHighlight(payload, () => {
                refreshSubtaskData();
            }));
        }

        setActiveTab(0);

        setSelectedTemplates(selectedTemplates)

    };
    const [taskConfirmMessage, setTaskConfirmMessage] = useState<string>('');
    const [isInitialConfirm, setIsInitialConfirm] = useState<boolean>(true);
    const [isDeleting, setIsDeleting] = useState<boolean>(false);

    const handleDeleteTask = () => {
        if (!taskId) return;
        const currentStageId = tasksView?.stageDataId?._id || stageId || tasksView?.stageId;
        if (currentStageId && stagebyproject && Array.isArray(stagebyproject)) {
            const stage = stagebyproject.find((s: any) => s._id === currentStageId || s.stageId?._id === currentStageId || s.stageId === currentStageId);
            if (stage && Array.isArray(stage.tasksNameList) && stage.tasksNameList.length <= 1) {
                const userRoles = auther?.Role || [];
                const rolesList = Array.isArray(userRoles)
                    ? userRoles.map((r: { RoleName?: string } | string) => (typeof r === 'string' ? r : r?.RoleName || '')?.trim()?.toLowerCase())
                    : [];
                const isSuperAdmin = rolesList.some((r: string) => r === 'super admin');
                const isProjectManager = rolesList.some((r: string) => r === 'project manager');

                if (!isSuperAdmin && !isProjectManager) {
                    toast.error("To delete this task, please contact to Super Admin.");
                    return;
                }
                toast("This task is the only remaining task in the stage, so it cannot be deleted individually. To remove it, please delete the entire stage.", { icon: '⚠️' });
                return;
            }
        }

        const currentStage = (stagebyproject && Array.isArray(stagebyproject))
            ? stagebyproject.find((s: any) => s._id === currentStageId || s.stageId?._id === currentStageId || s.stageId === currentStageId)
            : null;

        const taskToInspect = {
            ...tasksView,
            highlighters: tasksView?.highlighters || [],
            actions: tasksView?.actions || [],
            taskEstimateList: tasksView?.taskEstimateList || [],
            timeSpend: tasksView?.timeSpend || tasksView?.timeSpent || 0,
        };

        const userRoles = auther?.Role || [];
        const checkResult = checkDeletionPermission(taskToInspect, userRoles, 'task');
        console.log("Delete Task Confirmation Message (sideActions):", checkResult.message);

        if (!checkResult.allowed) {
            toast.error(checkResult.message);
            return;
        }

        setTaskConfirmMessage(checkResult.message);
        setIsInitialConfirm(true);
        setShowConfirmation(true);
    };

    const confirmDeleteTask = () => {
        if (isDeleting || !taskId) return;
        setIsDeleting(true);
        deleteTaskByIdApi(taskId, true).then(() => {
            setIsDeleting(false);
            dispatch(deleteTask(taskId));
            setShowConfirmation(false);
            if (stageId) {
                navigate(`/edit-stages/${stageId}`);
            }
        }).catch(() => {
            setIsDeleting(false);
            setShowConfirmation(false);
        });
    };

    const cancelDeleteTask = () => {
        if (isDeleting) return;
        setShowConfirmation(false);
    };
    const lastCreateHighlightRef = useRef<any>(null);
    const prevSelectedTabRef = useRef<string>('');
    const prevSubtaskParamsRef = useRef<{ taskId: string; stageId: string; selectedTab: string }>({
        taskId: '',
        stageId: '',
        selectedTab: ''
    });

    useEffect(() => {
        if (selectedTab === 'Subtask') {
            const createdActionType = createHighlight?.data?.actionType || createHighlight?.actionType || createHighlight?.payload?.actionType;
            const isSubtaskHighlight = createdActionType === "Subtask";
            const isNewHighlight = isSubtaskHighlight && createHighlight && createHighlight !== lastCreateHighlightRef.current;
            if (isNewHighlight) {
                lastCreateHighlightRef.current = createHighlight;
                dispatch(getActionHighlighterIds(actionObject, { name: "Subtask" }));
                dispatch(getAllSubtask(actionObject));
                dispatch(getAllSubtaskSummary(actionObject));
                dispatch(getAllDuplicateSubtasks(taskId));
            }
        }
    }, [selectedTab, createHighlight, taskId]);

    useEffect(() => {
        dispatch(getAllSubtaskSuccess({ requestedTaskId: null, isLoaded: false }));
        dispatch(getAllSubtaskSummarySuccess([]));
        dispatch(getAllDuplicateSubtasksSuccess({ data: { finalData: [] }, requestedTaskId: null, isLoaded: false }));
    }, [taskId, stageId]);

    useEffect(() => {
        if (selectedTab === 'Subtask') {
            const hasParamsChanged =
                prevSubtaskParamsRef.current.selectedTab !== 'Subtask' ||
                prevSubtaskParamsRef.current.taskId !== taskId ||
                prevSubtaskParamsRef.current.stageId !== stageId;

            if (hasParamsChanged) {
                prevSubtaskParamsRef.current = { selectedTab: 'Subtask', taskId, stageId };
                prevSelectedTabRef.current = 'Subtask';

                dispatch(getAllSubtaskSuccess({ requestedTaskId: null, isLoaded: false }));
                dispatch(getAllSubtaskSummarySuccess([]));
                dispatch(getAllDuplicateSubtasksSuccess({ data: { finalData: [] }, requestedTaskId: null, isLoaded: false }));
                dispatch(getActionByName(actionObject, { name: "Subtask" }));
                dispatch(getActionHighlighterIds(actionObject, { name: "Subtask" }));
                dispatch(getAllTemplateChecklist({ query: "subtasks" }));
                dispatch(getAllDuplicateSubtasks(taskId));
                dispatch(getAllSubtask(actionObject));
                dispatch(getAllSubtaskSummary(actionObject));
                dispatch(getAllSubtasksOfSameTask(actionObject));
            }
        } else {
            prevSubtaskParamsRef.current.selectedTab = selectedTab;
            prevSelectedTabRef.current = selectedTab;
        }
    }, [selectedTab, taskId, stageId, actionHighlights?._id]);
    let uniqueKeyCounter = 0;
    useEffect(() => {
        return (() => {
            dispatch(getAllSubtaskSummarySuccess([]))
        })
    }, [])

    const [colorMode] = useColorMode();
    const titleHeader = colorMode === 'light' ? "#0a0a0a" : "#dadada";

    const currentStageName = tasksView?.stageName || tasksView?.stageId?.name || tasksView?.stageDataName || stageId;
    const isPrelimOrFullStage = currentStageName === 'Prelim' || currentStageName === 'Full' ||
        tasksView?.stageName === 'Prelim' || tasksView?.stageName === 'Full' ||
        tasksView?.stageId?.name === 'Prelim' || tasksView?.stageId?.name === 'Full';

    const updatedSubtasks = useMemo(() => {
        if (!taskId || !allDuplicateSubtasks?.data?.finalData) return [];

        const requestedTaskId = allDuplicateSubtasks?.requestedTaskId || allDuplicateSubtasks?.data?.requestedTaskId;
        if (!requestedTaskId || String(requestedTaskId) !== String(taskId)) {
            return [];
        }

        const rawList = Array.isArray(allDuplicateSubtasks?.data?.finalData) ? allDuplicateSubtasks?.data?.finalData : [];
        const filteredList = isPrelimOrFullStage
            ? rawList.filter((subtask: any) => {
                const sStage = subtask.stageName || subtask.stageId;
                return sStage === 'Prelim' || sStage === 'Full';
            })
            : rawList.filter((subtask: any) => {
                const subtaskTaskId = typeof subtask.taskId === 'object' ? subtask.taskId?._id : subtask.taskId;
                return (subtaskTaskId && String(subtaskTaskId) === String(taskId)) || subtask.taskDataId === taskId;
            });

        return filteredList.map((subtask: any) => ({
            ...subtask,
            stageName: subtask.stageName || subtask.stageId,
        }));
    }, [allDuplicateSubtasks, taskId, isPrelimOrFullStage]);

    const currentTaskSubtasks = useMemo(() => {
        if (!taskId) return [];
        if (updatedSubtasks?.length) {
            return updatedSubtasks.filter((subtask: any) => {
                const subtaskTaskId = typeof subtask.taskId === 'object' ? subtask.taskId?._id : subtask.taskId;
                return subtaskTaskId === taskId || subtask.taskDataId === taskId;
            });
        }
        if (Array.isArray(AllSubtask?.allSubtask) && AllSubtask.allSubtask.length > 0) {
            return AllSubtask.allSubtask;
        }
        return [];
    }, [updatedSubtasks, taskId, AllSubtask]);

    const combinedPrelimFullSubtasks = useMemo(() => {
        if (!updatedSubtasks?.length) {
            if (Array.isArray(AllSubtask?.allSubtask) && AllSubtask.allSubtask.length > 0) {
                return AllSubtask.allSubtask;
            }
            return [];
        }
        return updatedSubtasks.filter(
            (subtask: any) => subtask?.stageName === 'Prelim' || subtask?.stageName === 'Full' || !subtask?.stageName
        );
    }, [updatedSubtasks, AllSubtask]);

    const effectiveSubtasks = useMemo(() => {
        if (isPrelimOrFullStage) {
            return combinedPrelimFullSubtasks;
        }
        return currentTaskSubtasks;
    }, [isPrelimOrFullStage, combinedPrelimFullSubtasks, currentTaskSubtasks]);

    const uniqueStageNames = new Set<string>();
    updatedSubtasks.forEach((subtask: any) => {
        if (subtask?.stageName) {
            uniqueStageNames.add(subtask?.stageName);
        }
    });
    const filterTasksByTaskId = (items: any[]) => {
        if (!Array.isArray(items) || !taskId) return items || [];

        const extractIdString = (val: any): string[] => {
            if (!val) return [];
            if (typeof val === 'string' || typeof val === 'number') return [String(val)];
            if (Array.isArray(val)) {
                return val.flatMap(extractIdString);
            }
            if (typeof val === 'object') {
                const ids: string[] = [];
                if (val._id) ids.push(...extractIdString(val._id));
                if (val.taskId) ids.push(...extractIdString(val.taskId));
                if (val.highlighterId) ids.push(...extractIdString(val.highlighterId));
                if (val.id) ids.push(...extractIdString(val.id));
                return ids;
            }
            return [];
        };

        return items.filter((subtask: any) => {
            if (!subtask) return false;
            const subtaskTaskIds = new Set<string>([
                ...extractIdString(subtask?.payload?.taskId),
                ...extractIdString(subtask?.taskId),
                ...extractIdString(subtask?.taskDataId),
            ]);

            return subtaskTaskIds.has(String(taskId));
        });
    };

    const isCurrentTaskAllSubtask = Boolean(
        AllSubtask &&
        (!AllSubtask.requestedTaskId || String(AllSubtask.requestedTaskId) === String(taskId))
    );

    const othersCategories: Record<string, any[]> = {
        BCs: isCurrentTaskAllSubtask ? filterTasksByTaskId(AllSubtask?.BCs) : [],
        PCs: isCurrentTaskAllSubtask ? filterTasksByTaskId(AllSubtask?.PCs) : [],
        Revs: isCurrentTaskAllSubtask ? filterTasksByTaskId(AllSubtask?.Revs) : [],
        BlockedByTrade: isCurrentTaskAllSubtask ? filterTasksByTaskId(AllSubtask?.allBlockedByTrade) : [],
        NewInfoAdded: isCurrentTaskAllSubtask ? filterTasksByTaskId(AllSubtask?.allNewNeedInfoAdded) : []
    };

    const isSubtaskResponseReady = useMemo(() => {
        if (!taskId) return false;
        const requestedTaskId = allDuplicateSubtasks?.requestedTaskId || allDuplicateSubtasks?.data?.requestedTaskId;
        const isDuplicateLoaded = Boolean(allDuplicateSubtasks?.isLoaded && requestedTaskId && String(requestedTaskId) === String(taskId));
        const isAllSubtaskLoaded = Boolean(AllSubtask?.isLoaded && (!AllSubtask?.requestedTaskId || String(AllSubtask?.requestedTaskId) === String(taskId)));
        return isDuplicateLoaded && isAllSubtaskLoaded;
    }, [taskId, allDuplicateSubtasks, AllSubtask]);

    const subtaskBadge = useMemo<ISubtaskBadgeData>(() => {
        if (!isSubtaskResponseReady) {
            const isCurrent = tasksView?._id ? String(tasksView._id) === String(taskId) : true;
            const counts = (isCurrent && tasksView?.displayCounts) || null;
            const isDoneFalse = Number(counts?.isDoneFalse) || 0;
            const isReviewedFalse = Number(counts?.isReviewedFalse) || 0;
            const donePercent = Number(counts?.donePercentage) || 0;

            return {
                isDoneFalse,
                isReviewedFalse,
                donePercent,
                showPercent: isDoneFalse > 0 || isReviewedFalse > 0 || donePercent > 0,
            };
        }

        let isDoneFalse = 0, isReviewedFalse = 0, total = 0, done = 0;
        const seen = new Set<string>();
        const allItems = [...(effectiveSubtasks || []), ...Object.values(othersCategories).flat()];

        allItems.forEach((subtask: any, idx: number) => {
            const list = subtask?.payload?.Description;
            if (Array.isArray(list)) {
                list.forEach((desc: any, dIdx: number) => {
                    const key = desc?._id ? String(desc._id) : `${subtask?._id || idx}_${desc?.name || dIdx}`;
                    if (seen.has(key)) return;
                    seen.add(key);

                    total += 1;
                    if (desc?.isDone ?? desc?.ischecked ?? desc?.isChecked) done += 1;
                    else isDoneFalse += 1;
                    if (!desc?.isReviewed) isReviewedFalse += 1;
                });
            }
        });

        return {
            isDoneFalse,
            isReviewedFalse,
            donePercent: total === 0 ? 0 : Number(((done / total) * 100).toFixed(1)),
            showPercent: total > 0,
        };
    }, [isSubtaskResponseReady, effectiveSubtasks, othersCategories, tasksView, taskId]);

    const othersTabs = Object.keys(othersCategories).filter(
        (key) => Array.isArray(othersCategories[key]) && othersCategories[key].length > 0
    );

    const isCurrentPrelim = currentStageName === 'Prelim' || tasksView?.stageName === 'Prelim' || tasksView?.stageId?.name === 'Prelim';
    const isCurrentFull = currentStageName === 'Full' || tasksView?.stageName === 'Full' || tasksView?.stageId?.name === 'Full';

    const hasOtherStageSubtasks = useMemo(() => {
        if (!combinedPrelimFullSubtasks?.length) return false;
        if (isCurrentPrelim) {
            return combinedPrelimFullSubtasks.some((subtask: any) => {
                const sName = subtask?.stageName || subtask?.stageId?.name || subtask?.stageId;
                return sName === 'Full';
            });
        }
        if (isCurrentFull) {
            return combinedPrelimFullSubtasks.some((subtask: any) => {
                const sName = subtask?.stageName || subtask?.stageId?.name || subtask?.stageId;
                return sName === 'Prelim';
            });
        }
        const hasPrelim = combinedPrelimFullSubtasks.some((s: any) => (s?.stageName || s?.stageId?.name || s?.stageId) === 'Prelim');
        const hasFull = combinedPrelimFullSubtasks.some((s: any) => (s?.stageName || s?.stageId?.name || s?.stageId) === 'Full');
        return hasPrelim && hasFull;
    }, [combinedPrelimFullSubtasks, isCurrentPrelim, isCurrentFull]);

    const stageNames = ['All Subtasks', ...othersTabs];
    if (isPrelimOrFullStage && hasOtherStageSubtasks) {
        stageNames.push('Prelim/Full');
    }

    // const stageNames = ["Prelim", "Full", "Rev"];
    const [activeTab, setActiveTab] = useState(() => {
        const matchedSubtask = updatedSubtasks?.find(
            (subtask: any) => subtask?.stageId === tasksView?.stageDataId?._id
        );

        return matchedSubtask ? stageNames?.indexOf(matchedSubtask?.stageName) : 0;
    });

    useEffect(() => {
        if (activeTab >= stageNames.length) {
            setActiveTab(0);
        }
    }, [stageNames.length, activeTab]);

    const handleDeleteCheckboxChange = (index: number, isChecked: boolean, deleteID: string, action: any) => {
        setDeleteIdList(prev => {
            let updatedDeleteData;
            if (isChecked) {
                updatedDeleteData = [...prev, deleteID];
            } else {
                updatedDeleteData = prev.filter(id => id !== deleteID);
            }
            return updatedDeleteData;
        });
    };

    const handleTabChange = (index: number) => {
        setActiveTab(index);
    };

    const handleDeleteSubtasks = () => {
        setShowConfirmationTask(true)
    }

    const handleConfirmDeleteSelectedTasks = () => {
        const subtaskIdMap: { [key: string]: string[] } = {};
        deleteIdList.forEach(descId => {
            updatedSubtasks.forEach((subtask: any) => {
                if (subtask._id && subtask.payload?.Description?.some((desc: any) => desc._id === descId || desc.id === descId || desc.name === descId)) {
                    if (!subtaskIdMap[subtask._id]) {
                        subtaskIdMap[subtask._id] = [];
                    }
                    subtaskIdMap[subtask._id].push(descId);
                }
            });
        });

        Object.entries(subtaskIdMap).forEach(([subtaskId, descIds]) => {
            if (subtaskId && subtaskId !== "undefined") {
                dispatch(deleteMultipleActionHighlight({ subtaskIds: descIds }, subtaskId));
            }
        });

        if (Object.keys(subtaskIdMap).length === 0 && actionHighlights?._id && actionHighlights._id !== "undefined") {
            dispatch(deleteMultipleActionHighlight({ subtaskIds: deleteIdList }, actionHighlights._id));
        }
        refreshSubtaskData();
        setShowConfirmationTask(false);
        lastFetchRef.current = "";
        setPageNumber(1);
    };
    const modalHeader = colorMode === 'light' ? "#fff" : "#20283c";
    const getUserProfileIcon = (firstName: string, lastName: string) => {
        const firstLetter = firstName.charAt(0).toUpperCase();
        const lastLetter = lastName.charAt(0).toUpperCase();
        return <div style={{
            backgroundColor: "#7743DB",
            color: "#fff",
            width: '50px',
            height: '40px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            {firstLetter.charAt(0).toUpperCase()}{lastLetter.charAt(0).toUpperCase()}
        </div>
    }
    return (
        <>
            <div className='p-3' style={{ width: '30%', maxHeight: "845px", borderLeft: `2px solid ${theme?.colors?.lightbackground}`, overflowX: "hidden", position: 'relative' }}  >
                {selectedTab === 'activity' && (
                    <>

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div>
                                <h5>Activity</h5>
                                <p style={{ color: titleHeader }}>All Activities</p>
                            </div>
                            <div>
                                {allowRoles && (<Image src={clockleft} alt={'History'} style={{ width: 25, marginRight: '15px', cursor: 'pointer' }} onClick={toggleHistoryModal} />)}

                                <Image src={notification1} alt={'History'} style={{ width: 30, cursor: 'pointer' }} onClick={toggleActivityModal} />
                            </div>

                        </div>
                        <div>
                            {uniqueItems?.length === 0 && historyLoader ? (
                                <Box sx={{ textAlign: 'center', mt: 4 }}>
                                    <Spinner />
                                </Box>
                            ) : (
                                <InfiniteScroll
                                    dataLength={uniqueItems?.length || 0}
                                    next={fetchMoreData}
                                    hasMore={hasMore}
                                    loader={<Box sx={{ textAlign: "center" }}><Spinner /></Box>}
                                    height={600}
                                    endMessage={<p ></p>}

                                >
                                    {(() => {
                                        const seenTexts = new Set<string>();
                                        return uniqueItems?.map((history: any, index: number) => {
                                            const activityText = AllActivities(
                                                history?.action,
                                                history?.changes ? { ...history?.changes, stageId: history?.stageId || history?.changes?.stageId, taskId: history?.taskId || history?.changes?.taskId } : (history?.stageId || history?.taskId ? { stageId: history?.stageId, taskId: history?.taskId } : history?.changes),
                                                history?.oldData ? { ...history?.oldData, stageId: history?.stageId || history?.oldData?.stageId, taskId: history?.taskId || history?.oldData?.taskId } : (history?.stageId || history?.taskId ? { stageId: history?.stageId, taskId: history?.taskId } : history?.oldData),
                                                dataForTable?.data?.allProjectManagers,
                                                dataForTable?.data?.allTaskManagers,
                                                dataForTable?.data?.allProjectWorkers,
                                                dataForTable?.data?.allTaskWorkers,
                                                dataForTable?.data?.allHighlighters,
                                                dataForTable?.data?.allArchitects,
                                                false,
                                                dataForTable?.data?.allStages,
                                                dataForTable?.data?.allTask?.data || dataForTable?.data?.allTask || dataForTable?.data?.allTasks
                                            );
                                            if (!activityText) return null;
                                            const timeKey = history?.createdAt ? moment(history.createdAt).format('YYYY-MM-DD-HH:mm') : index;
                                            const normalized = `${timeKey}_${activityText.toLowerCase().replace(/['"\s_-]/g, '')}`;
                                            if (seenTexts.has(normalized)) return null;
                                            seenTexts.add(normalized);

                                            // Find the dynamic key that matches 'payload.Description.<number>'
                                            const dynamicKey = Object.keys(history?.changes || {}).find(key => key.match(/^payload\.Description\.\d+$/));

                                            // Determine the createdBy value based on the conditions
                                            const createdBy = dynamicKey && history?.changes[dynamicKey]
                                                ? history?.changes[dynamicKey]?.createdBy
                                                : history?.changes?.updateObject?.createdBy ||
                                                history?.changes?.updateObject?.updatedBy ||
                                                history?.changes?.updatedBy ||
                                                (Array.isArray(history?.changes?.payload?.Description)
                                                    ? history?.changes?.payload?.Description[0]?.createdBy
                                                    : 'Someone');
                                            return (
                                                <React.Fragment key={index}>
                                                    <Paragraph style={{ gap: 2, marginRight: '5px' }} variant="activityText">
                                                        <strong style={{ marginRight: '6px' }}>{getUserName(createdBy, dataForTable?.data)}</strong>
                                                        {' '}{activityText}
                                                    </Paragraph>
                                                    <Paragraph sx={{ textAlign: "end", fontSize: "10px", color: "#D3D5D9", marginBottom: "0px" }}>
                                                        {moment(history?.createdAt).format('MMM DD, LT')}
                                                    </Paragraph>
                                                </React.Fragment>
                                            );
                                        });
                                    })()}
                                </InfiniteScroll>
                            )}

                        </div>
                        <ActivityRevertHistory isOpen={historyModalOpen} togglePopover={toggleHistoryModal} items={items}
                            hasMore={hasMore}
                            fetchMoreData={fetchMoreData}
                            dataForTable={dataForTable}
                            view="Task"
                            taskId={taskId}
                            colorMode={colorMode}
                        />
                    </>
                )}
                {selectedTab === 'Subtask' && (
                    <>
                        <div>
                            <h5>Subtask</h5>
                        </div>
                        <div>

                            <form onSubmit={handleSubmit}>
                                <Box sx={{ paddingX: "2rem", mt: "1.5rem", position: "relative", display: 'flex' }}>
                                    <Inputform
                                        label={"Create Subtask"}
                                        Placeholder={"Enter Subtask..."}
                                        Name={"name"}
                                        Title_sx={{ color: "grey3" }}
                                        sx={{ color: colorMode === "light" ? "secondary" : "white" }}
                                        touched={touched?.name}
                                        errors={errors?.name}
                                        values={values.name}
                                        Max_Length={10}
                                        onBlur={handleBlur}
                                        OnChange={(event: any) => {
                                            const newSubtask = event.target.value;
                                            setFieldValue("name", newSubtask, true);
                                        }}
                                    />
                                    <Button type='submit' sx={{ display: "flex", alignItems: "center", position: "absolute", right: "30px", top: "50px", borderRadius: "8px", paddingLeft: "12px" }}><FaPlus className="mx-1" />Add</Button>

                                </Box>
                            </form>
                            <Divider sx={{ mt: "1.5rem" }} />
                            <Box sx={{ display: "grid", gap: "1rem", position: "relative" }}>
                                <Box className="row">
                                    <Box className="col-6">
                                        <Paragraph sx={{ fontSize: "18px", fontWeight: "600", mb: "0.5rem" }}>All subtask</Paragraph>
                                    </Box>

                                    <Box className="col-12">
                                        <FormSelect
                                            placeholder="Predefined Checklist"
                                            options={templateOptions}
                                            value={templateOptions?.find((option: any) => selectedTemplates?._id === option.value)}
                                            onChange={handleTemplateChange}
                                            scrollable={true}
                                        />
                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                                    <Button onClick={handleDeleteSubtasks}>Delete</Button>
                                </Box>
                                <Box className="mt-2" sx={{ position: 'relative', minHeight: '200px' }}>
                                    {!isSubtaskResponseReady ? (
                                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px', width: '100%' }}>
                                            <Spinner />
                                        </Box>
                                    ) : (
                                        <Tabs selectedIndex={activeTab} onSelect={handleTabChange}>
                                        <Box sx={{
                                            width: "100%", scrollbarWidth: "none", overflowX: "auto"
                                        }}>
                                            <TabList
                                                style={{
                                                    borderBottom: '1px solid #ccc',
                                                }}
                                            >
                                                {stageNames?.map((stageName) => (
                                                    <Tab
                                                        key={stageName}
                                                        style={{
                                                            flex: '0 0 auto',
                                                            minWidth: '120px',
                                                            textAlign: 'center',
                                                            whiteSpace: 'normal',

                                                        }}
                                                    >
                                                        {stageName}
                                                    </Tab>
                                                ))}
                                            </TabList>
                                        </Box>



                                        {stageNames?.map((stageName: string, stageIndex: number) => {
                                            if (stageName === 'All Subtasks') {
                                                return (
                                                    <TabPanel key={stageIndex}>
                                                        {currentTaskSubtasks?.length > 0 ? (
                                                            currentTaskSubtasks.map((subtask: any, subtaskIndex: number) => (
                                                                <div key={subtaskIndex}>
                                                                    {subtask?.payload?.Description?.length > 0 ? (
                                                                        subtask?.payload?.Description.map((description: any, desIndex: number) => (
                                                                            <React.Fragment key={desIndex}>
                                                                                <ActionCard
                                                                                    key={desIndex}
                                                                                    index={desIndex}
                                                                                    action={description}
                                                                                    comment={false}
                                                                                    selectedHighlight={subtask?.actionType}
                                                                                    keys={{ first: "isDone", third: "isReviewed" }}
                                                                                    actionObject={actionObject}
                                                                                    parentData={subtask}
                                                                                    actionId={subtask?._id}
                                                                                    parentName={"Sub"}
                                                                                    handleDeleteCheckboxChange={handleDeleteCheckboxChange}
                                                                                    deleteIdList={deleteIdList}
                                                                                />
                                                                                <Paragraph
                                                                                    sx={{
                                                                                        textAlign: 'end',
                                                                                        fontSize: '10px',
                                                                                        opacity: '0.5',
                                                                                        marginBottom: '0px',
                                                                                    }}
                                                                                >
                                                                                    {description?.updatedAt && moment(description?.updatedAt).format('MMM DD, LT')}
                                                                                </Paragraph>
                                                                            </React.Fragment>
                                                                        ))
                                                                    ) : null}
                                                                </div>
                                                            ))
                                                        ) : AllSubtask?.allSubtask?.length > 0 ? (
                                                            AllSubtask?.allSubtask?.map((item: any, index: number) => (
                                                                <div key={index}>
                                                                    {/* Render your task descriptions here */}
                                                                    {Object.keys(item)?.map((action: any) =>
                                                                        item[action]?.Description?.map((description: any, desIndex: number) => (
                                                                            <React.Fragment key={desIndex}>
                                                                                <ActionCard
                                                                                    key={uniqueKeyCounter++}
                                                                                    index={uniqueKeyCounter}
                                                                                    action={description}
                                                                                    comment={false}
                                                                                    keys={{ first: "isDone", third: "isReviewed" }}
                                                                                    actionObject={
                                                                                        item?.actionType !== "Subtask" ? { ...actionObject, taskId: null } : actionObject
                                                                                    }
                                                                                    parentData={item}
                                                                                    parentName={"Sub"}
                                                                                    handleDeleteCheckboxChange={handleDeleteCheckboxChange}
                                                                                    deleteIdList={deleteIdList}
                                                                                />
                                                                                <Paragraph
                                                                                    sx={{
                                                                                        textAlign: 'end',
                                                                                        fontSize: '10px',
                                                                                        opacity: '0.5',
                                                                                        marginBottom: '0px',
                                                                                    }}
                                                                                >
                                                                                    {description?.updatedAt && moment(description?.updatedAt).format('MMM DD, LT')}
                                                                                </Paragraph>
                                                                            </React.Fragment>
                                                                        ))
                                                                    )}
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <p>No All Subtasks available.</p>
                                                        )}
                                                    </TabPanel>
                                                );
                                            }
                                            else if (stageName === 'Prelim/Full') {
                                                return (
                                                    <TabPanel key={stageIndex}>
                                                        {combinedPrelimFullSubtasks.length > 0 ? (
                                                            combinedPrelimFullSubtasks.map((subtask: any, subtaskIndex: number) => (
                                                                <div key={subtaskIndex}>
                                                                    {subtask?.payload?.Description?.length > 0 ? (
                                                                        subtask?.payload?.Description.map((description: any, desIndex: number) => (
                                                                            <ActionCard
                                                                                key={desIndex}
                                                                                index={desIndex}
                                                                                action={description}
                                                                                comment={false}
                                                                                selectedHighlight={subtask?.actionType}
                                                                                keys={{ first: "isDone", third: "isReviewed" }}
                                                                                actionObject={actionObject}
                                                                                parentData={subtask}
                                                                                actionId={subtask?._id}
                                                                                handleDeleteCheckboxChange={handleDeleteCheckboxChange}
                                                                                deleteIdList={deleteIdList}
                                                                            />
                                                                        ))
                                                                    ) : (
                                                                        null
                                                                    )}
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <p>No Prelim/Full subtasks available.</p>
                                                        )}
                                                    </TabPanel>
                                                );
                                            }
                                            else if (othersTabs.includes(stageName)) {
                                                const tasks = othersCategories[stageName];

                                                return (
                                                    <TabPanel key={stageIndex}>
                                                        {tasks.map((subtask: any, subtaskIndex: number) => (
                                                            <div key={subtaskIndex}>
                                                                {subtask?.payload?.Description?.length > 0 ? (
                                                                    subtask?.payload?.Description?.map((description: any, desIndex: number) => (
                                                                        <React.Fragment key={desIndex}>
                                                                            <ActionCard
                                                                                key={desIndex}
                                                                                index={desIndex}
                                                                                action={description}
                                                                                comment={false}
                                                                                selectedHighlight={subtask?.actionType}
                                                                                keys={{ first: "isDone", third: "isReviewed" }}
                                                                                actionObject={actionObject}
                                                                                parentData={subtask}
                                                                                actionId={subtask?._id}
                                                                                handleDeleteCheckboxChange={handleDeleteCheckboxChange}
                                                                                deleteIdList={deleteIdList}
                                                                                isOthersTab={true}
                                                                                isShowDeleteCheckbox={false}
                                                                            />
                                                                            <Paragraph
                                                                                sx={{
                                                                                    textAlign: 'end',
                                                                                    fontSize: '10px',
                                                                                    opacity: '0.5',
                                                                                    marginBottom: '0px',
                                                                                }}
                                                                            >
                                                                                {description?.updatedAt && moment(description?.updatedAt).format('MMM DD, LT')}
                                                                            </Paragraph>
                                                                        </React.Fragment>
                                                                    ))
                                                                ) : (
                                                                    <p>{`No subtasks available in ${stageName}.`}</p>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </TabPanel>
                                                );
                                            }
                                            else {
                                                // Existing logic for other stage names
                                                let filteredStageSubtasks = updatedSubtasks.filter((subtask: any) => subtask?.stageName === stageName);

                                                return (
                                                    <TabPanel key={stageIndex}>
                                                        {filteredStageSubtasks.length > 0 ? (
                                                            filteredStageSubtasks.map((subtask: any, subtaskIndex: number) => (
                                                                <div key={subtaskIndex}>
                                                                    {subtask?.payload?.Description?.length > 0 ? (
                                                                        subtask?.payload?.Description.map((description: any, desIndex: number) => (
                                                                            <ActionCard
                                                                                key={desIndex}
                                                                                index={desIndex}
                                                                                action={description}
                                                                                comment={false}
                                                                                selectedHighlight={subtask?.actionType}
                                                                                keys={{ first: "isDone", third: "isReviewed" }}
                                                                                actionObject={actionObject}
                                                                                parentData={subtask}
                                                                                actionId={subtask?._id}
                                                                                handleDeleteCheckboxChange={handleDeleteCheckboxChange}
                                                                                deleteIdList={deleteIdList}
                                                                            />
                                                                        ))
                                                                    ) : (
                                                                        <p>{`No ${stageName} subtasks available.`}</p>
                                                                    )}
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <p>{`No ${stageName} subtasks available.`}</p>
                                                        )}
                                                    </TabPanel>
                                                );
                                            }
                                        })}

                                        </Tabs>
                                    )}
                                </Box>
                                {selectedTab !== 'Subtask' && loader && <Box sx={{ position: "absolute", inset: "0", width: "100%", height: "100%", backgroundColor: 'rgba(255, 255, 255, 0.5)', display: "grid", placeContent: "center" }}><Spinner /></Box>}
                            </Box>
                            <Modal isOpen={showConfirmationTask} toggle={cancelMultipleDeleteTask} size="sm" centered>
                                <ModalHeader toggle={cancelMultipleDeleteTask} style={{ backgroundColor: modalHeader, color: titleHeader }}>Confirm Deletion</ModalHeader>
                                <ModalBody style={{ backgroundColor: modalHeader, color: titleHeader }}>
                                    {`Are you sure you want to delete the selected tasks?`}
                                </ModalBody>
                                <ModalFooter style={{ backgroundColor: modalHeader, color: titleHeader }}>
                                    <Button variant="CancelButton" sx={{ mr: 2, cursor: 'pointer' }} onClick={cancelMultipleDeleteTask}>No</Button>
                                    <Button
                                        type="button"
                                        variant="SaveButton"
                                        sx={{ cursor: 'pointer' }}
                                        onClick={handleConfirmDeleteSelectedTasks}
                                    >
                                        Yes
                                    </Button>
                                </ModalFooter>
                            </Modal>
                        </div>
                    </>
                )}
                {selectedTab === 'thread' && (
                    <div>
                        <h5>Chat section</h5>
                        <p className='text-muted'>All Chats</p>
                    </div>
                )}
                {selectedTab === 'spent' && (
                    <>
                        <div className="d-flex" style={{ justifyContent: 'space-between', alignItems: 'flex-start' }}>
                            <div className="text-left">
                                <h5>Time Tracking</h5>
                                <p style={{ color: colorMode === 'light' ? "muted" : "#fff" }}>Spend history</p>
                            </div>

                            <div className="d-flex flex-column align-items-end">
                                <MenuButton aria-label="Toggle Menu" />
                                <Text sx={{ color: colorMode === 'light' ? "muted" : "#fff" }} >
                                    Total TDPR: <Text as="span" sx={{ fontWeight: 'bold', color: colorMode === 'light' ? "black" : "#fff" }}>{timeInHoursMinutesSeconds}</Text>
                                </Text>
                            </div>
                        </div>
                        <div className="text-center mt-2">
                            {(isTracking !== null && Latesttime?.userId?._id === auther?._id) && <>
                                <p>Tracking Started</p>
                                <h1 style={{ color: `${timeStatusColor}` }}>{elapsedTime}</h1>
                            </>
                            }

                        </div>

                        <hr />

                        <div className="container-fluid">
                            <div className="row mb-4">
                                <div className="col-md-8"><h5>Last Actions<Badge variant='circle' mt={-3}>{spentTime?.data?.length}</Badge></h5></div>
                                <div className="col-md-4">
                                    {spentTime?.data?.length > 5 && (
                                        <div>
                                            {showAll ? (
                                                <Button variant="spentButton" onClick={() => setShowAll(false)}>Show Less</Button>
                                            ) : (
                                                <Button variant="spentButton" onClick={() => setShowAll(true)}>Show All</Button>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div style={{ maxHeight: '675px', overflow: 'auto' }}>
                                {showAll ? (
                                    spentTime?.data?.filter((time: { timeTaken: any; }) => time?.timeTaken).map((time: any, index: React.Key | null | undefined) => {
                                        const { hours, minutes, seconds, days } = convertMillisecondsToHoursMinutesSeconds(time?.timeTaken);
                                        const formattedDay = days > 0 ? `${days}d` : "";
                                        const formattedHours = hours > 0 ? `${hours}h` : "";
                                        const formattedMinutes = minutes > 0 ? `${minutes}m` : "";
                                        const formattedSeconds = seconds > 0 ? `${seconds}s` : "";
                                        const profileImage = `${bucketUrl}${time?.userId?.ProfileImage}`;
                                        return (
                                            <div className="spenttime" key={index}>
                                                <div className="conatainer-fluid">
                                                    <div className="row">
                                                        <div className="col-md-2 m-0 d-flex">
                                                            {time?.userId?.ProfileImage ? <Image src={profileImage} alt="" style={{ width: "50px", height: "40px", borderRadius: "50%", objectFit: "inherit" }} variant="avatar" /> : getUserProfileIcon(time?.userId?.FirstName, time?.userId?.LastName)}
                                                        </div>
                                                        <div className="col-md-5">
                                                            <p className="mb-0">{time?.userId?.FirstName} {time?.userId?.LastName}</p>
                                                            <p className=" mt-0" style={{ color: titleHeader, overflowWrap: "break-word", wordBreak: "break-all" }}>{time?.description}</p>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <p className="d-flex">{formattedDay}{" "}{formattedHours}{" "}{formattedMinutes}{" "}{formattedSeconds}</p>
                                                            <p className="mt-0">{moment(time?.createdAt).format('ll')}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    spentTime?.data?.filter((time: { timeTaken: any; }) => time?.timeTaken).slice(0, 5).map((time: any, index: React.Key | null | undefined) => {
                                        const { hours, minutes, seconds, days } = convertMillisecondsToHoursMinutesSeconds(time?.timeTaken);
                                        const formattedDay = days > 0 ? `${days}d` : "";
                                        const formattedHours = hours > 0 ? `${hours}h` : "";
                                        const formattedMinutes = minutes > 0 ? `${minutes}m` : "";
                                        const formattedSeconds = seconds > 0 ? `${seconds}s` : "";
                                        const profileImage = `${bucketUrl}${time?.userId?.ProfileImage}`;
                                        return (
                                            <div className="spenttime" key={index}>
                                                <div className="conatainer-fluid">
                                                    <div className="row">
                                                        <div className="col-md-2 m-0 d-flex">
                                                            {time?.userId?.ProfileImage ? <Image src={profileImage} alt="" style={{ width: "50px", height: "40px", borderRadius: "50%", objectFit: "inherit" }} variant="avatar" /> : getUserProfileIcon(time?.userId?.FirstName, time?.userId?.LastName)}
                                                        </div>
                                                        <div className="col-md-5">
                                                            <p className="mb-0">{time?.userId?.FirstName} {time?.userId?.LastName}</p>
                                                            <p className=" mt-0" style={{ color: titleHeader, overflowWrap: "break-word", wordBreak: "break-all" }}>{time?.description}</p>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <p className="d-flex">{formattedDay}{" "}{formattedHours}{" "}{formattedMinutes}{" "}{formattedSeconds}</p>
                                                            <p className="mt-0">{moment(time?.createdAt).format('ll')}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                )}
                            </div>

                        </div>
                    </>
                )}
                {selectedTab === 'action' && (
                    <div>
                        <h5>Actions</h5>
                        <p className='text-muted'>All Actions</p>
                    </div>
                )}
            </div>
            <ActivityHistoryModal
                isOpen={modalOpen}
                toggle={toggleActivityModal}
                items={items}
                hasMore={hasMore}
                fetchMoreData={fetchMoreData}
                dataForTable={dataForTable}
                colorMode={colorMode}
            />
            <div className=' text-center col-md-1 p-3 ' style={{ borderLeft: `2px solid ${theme?.colors?.lightbackground}` }}>
                <div onClick={() => handleTabClick('activity')}>
                    <button className='btn' style={{ backgroundColor: selectedTab === 'activity' && colorMode === "light" ? `${theme?.colors?.lightbackground}` : selectedTab === 'activity' && colorMode === "dark" ? `#515568` : 'inherit' }}>
                        <Image src={activity} alt='' style={{ fill: selectedTab === 'activity' ? `${theme?.colors?.lightbackground}` : 'inherit' }} />
                    </button>
                </div>
                <Text className='mt-1' sx={{ cursor: 'pointer' }}>Activity</Text>

                <ThreadModalPop handleTabClick={handleTabClick} selectedTab={selectedTab} phaseId={taskId} level="task" threads={threads} />
                <div onClick={() => handleTabClick('spent')} >
                    <button className='btn ' style={{ backgroundColor: selectedTab === 'spent' && colorMode === "light" ? `${theme?.colors?.lightbackground}` : selectedTab === 'spent' && colorMode === "dark" ? `#515568` : 'inherit' }}>
                        <Image src={spent} alt='' style={{ fill: selectedTab === 'spent' ? `${theme?.colors?.lightbackground}` : 'inherit' }} />
                    </button>
                    <p className='mt-1' style={{ cursor: 'pointer' }}>Spent History</p>
                </div>
                <div onClick={() => handleTabClick('Subtask')} style={{ position: 'relative' }}>
                    {subtaskBadge.showPercent && (
                        <Badge
                            sx={{
                                position: 'absolute',
                                left: '-2px',
                                top: '0px',
                                borderRadius: '12px',
                                backgroundColor: '#0d6efd',
                                color: '#fff',
                                fontWeight: 'bold',
                                zIndex: 2,
                                pointerEvents: 'none',
                            }}
                        >
                            {subtaskBadge.donePercent}%
                        </Badge>
                    )}
                    <button className='btn ' style={{ backgroundColor: selectedTab === 'Subtask' ? `${theme?.colors?.lightbackground}` : 'inherit', position: 'relative' }}>
                        <Image src={taskIcon} alt='' style={{ fill: selectedTab === 'Subtask' ? `${theme?.colors?.lightbackground}` : 'inherit' }} />
                        {subtaskBadge.isDoneFalse > 0 && (
                            <Badge className="px-2" sx={{ position: 'absolute', top: '-4px', right: '-14px', borderRadius: '15px', backgroundColor: `${theme?.colors?.green}` }}>
                                {subtaskBadge.isDoneFalse}
                            </Badge>
                        )}
                        {subtaskBadge.isReviewedFalse > 0 && (
                            <Badge className="px-2" sx={{ position: 'absolute', top: '21px', right: '-15px', borderRadius: '15px', backgroundColor: `${theme?.colors?.musterd}` }}>
                                {subtaskBadge.isReviewedFalse}
                            </Badge>
                        )}
                    </button>
                    <p className='mt-1' style={{ cursor: 'pointer' }}>Subtask</p>
                </div>
                <HistoryAction selectedTab={selectedTab} stageDataId={stageId} projectId={projectId} taskId={taskId} viewtask='task' />

                <AddAction selectedTab={selectedTab} taskId={taskId} handleTabClick={handleTabClick} />

                {is_Project_Worker || is_Project_Manager || is_Super_Admin ? (
                    <Box sx={{ alignItems: 'center', cursor: 'pointer' }} className="mt-5">
                        <img src={deleteIcon} alt='Delete' onClick={handleDeleteTask} style={{ height: '25px', width: '25px' }} />
                    </Box>
                ) : null}
            </div>

            <Modal isOpen={isPopoverOpen} toggle={togglePopover} centered>
                <ModalHeader>Need Info</ModalHeader>
                <ModalBody>
                    <textarea className="form-control" placeholder="enter need info..." value={textareaValue} onChange={handleTextareaChange}></textarea>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={handleSend}>Send</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={showConfirmation} toggle={cancelDeleteTask} size="sm" centered>
                <ModalHeader toggle={cancelDeleteTask} style={{ backgroundColor: modalHeader, color: titleHeader }}>Confirm Deletion</ModalHeader>
                <ModalBody style={{ backgroundColor: modalHeader, color: titleHeader }}>
                    {taskConfirmMessage || `Are you sure you want to delete ${tasksView?.taskId?.name} task?`}
                </ModalBody>
                <ModalFooter style={{ backgroundColor: modalHeader, color: titleHeader }}>
                    <Button variant="CancelButton" sx={{ mr: 2, cursor: isDeleting ? 'not-allowed' : 'pointer' }} onClick={cancelDeleteTask} disabled={isDeleting}>No</Button>
                    <Button type="button" variant="SaveButton" sx={{ cursor: isDeleting ? 'not-allowed' : 'pointer' }} onClick={confirmDeleteTask} disabled={isDeleting}>
                        {isDeleting ? <Spinner size={16} sx={{ color: '#fff' }} /> : 'Yes'}
                    </Button>
                </ModalFooter>

            </Modal>
        </>
    )
};
export default SideActions;
